import axios from '../axios';
// 员工列表分页信息
export const getBaseEmployeePage = data => {
  return axios({
    url: '/api/sys/base/employee/getBaseEmployeePage',
    method: 'post',
    data
  })
};
// 员工查单条
export const getBaseEmployee = data => {
  return axios({
    url: '/api/sys/base/employee/getBaseEmployee',
    method: 'post',
    data
  })
};
// 删除
export const del = data => {
  return axios({
    url: '/api/sys/base/employee/deleteBaseEmployees',
    method: 'post',
    data
  })
};
// 生成对应用户
export const user = data => {
  return axios({
    url: '/api/base/employee/enable_log',
    method: 'post',
    data
  })
};
export const save = data => {
  // 增
  if (!data.id) {
    return axios({
      url: '/api/sys/base/employee/saveBaseEmployee',
      method: 'post',
      data
    })
  } else {
    // 改
    return axios({
      url: '/api/sys/base/employee/updateBaseEmployee',
      method: 'post',
      data
    })
  }
}
// 生成对应用户
export const updateBaseEmployee = data => {
  return axios({
    url: '/api/base/employee/updateBaseEmployee',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/api/moudules/employee.js